<template>
    <v-container app :fluid="true">
        <template>

            <v-row>
                <v-col cols="10" class="pt-1 h-100">
                    <span class="headline font-weight-medium">Impresoras</span>
                </v-col>
            </v-row>

            <v-row justify="center">
                <v-col cols="6">
                    <v-card>
                        <v-card-title>
                            <span>Impresora Código de Barras</span>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <v-combobox
                                            v-model="impresora_barcode"
                                            label="Impresora para códigos de barras"
                                            :items="impresoras"
                                            outlined
                                            hide-details>
                                        </v-combobox>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <v-btn
                                            dark
                                            color="success"
                                            @click="setImpresoraBarcode"
                                        >
                                            Guardar
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-col>
                <!--
                <v-col cols="6">
                    <v-card>
                        <v-card-title>
                            <span>Impresora Tickets</span>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <v-combobox
                                            v-model="impresora_tickets"
                                            label="Impresora para tickets"
                                            :items="impresoras"
                                            outlined
                                            hide-details>
                                        </v-combobox>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <v-btn
                                            dark
                                            color="success"
                                            @click="setImpresoraTickets"
                                        >
                                            Guardar
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-col>
                -->
            </v-row>

        </template>
    </v-container>
</template>

<script>
import printUtil from '@/plugins/print';
import cloneDeep from 'lodash/cloneDeep';

export default {
    name: 'Printers',
    data() {
        return {
            impresoras: [],
            impresora_tickets: '',
            impresora_cotizaciones: '',
            impresora_barcode: ''
        }
    },
    created() {
        this.impresora_tickets = localStorage.getItem('impresora_tickets')
        this.impresora_cotizaciones = localStorage.getItem('impresora_cotizaciones')
        this.impresora_barcode = localStorage.getItem('impresora_barcode')
        let print = new printUtil()
        print.launch().then(() => {
            console.log('CONECTADO')
            print.findPrinters().then((resp) => {
                this.impresoras = cloneDeep(resp);
            }).catch((err) => {
                console.error(err)
            })
        })
    },
    methods:
    {
        setImpresoraTickets() {
            localStorage.setItem('impresora_tickets', this.impresora_tickets);
            this.$notify({
                group: 'foo',
                type: 'success',
                title: 'IMPRESORA',
                text: 'Impresora seleccionada de manera exitosa!'
            });
        },
        setImpresoraBarcode() {
            localStorage.setItem('impresora_barcode', this.impresora_barcode);
            this.$notify({
                group: 'foo',
                type: 'success',
                title: 'IMPRESORA CÓDIGO DE BARRAS',
                text: 'Impresora para códigos de barras seleccionada de manera exitosa!'
            });
        },
        setImpresoraCotizaciones() {
            localStorage.setItem('impresora_cotizaciones', this.impresora_cotizaciones);
        }
    }
}
</script>

<style scoped>

</style>